// Shared staleTime constants for React Query hooks
// See CLAUDE.md "staleTime Defaults" for rationale

/** 10 seconds — near-realtime data (e.g., WhatsApp messages, unread counts) */
export const STALE_10SEC = 1000 * 10;

/** 30 seconds — frequently changing data needing near-realtime feel */
export const STALE_30SEC = 1000 * 30;

/** 1 minute — volatile data (e.g., CRM lead activities, reminders) */
export const STALE_1MIN = 1000 * 60;

/** 2 minutes — moderate freshness (e.g., analytics, stats, admin lists) */
export const STALE_2MIN = 1000 * 60 * 2;

/** 5 minutes — user-generated content (e.g., projects, blogs, leads) */
export const STALE_5MIN = 1000 * 60 * 5;

/** 1 hour — rarely-changing data (e.g., taxonomy, templates, categories) */
export const STALE_1HR = 1000 * 60 * 60;
